// Questions shown in the "Sıkça Sorulan Sorular" section. Source: docs/COMPANY_FACTS.md (FAQ).
// AV5 renders the FAQPage JSON-LD from this same array, so the two can't drift.
export const faq = {
  tr: [
    {
      question: "Alesta Innovation nedir?",
      answer:
        "Alesta Innovation (Alesta Teknoloji Yazılım ve Danışmanlık Ltd. Şti.), 2023 yılında Hüseyin Doruk Tunca ve Semih Birincioğlu tarafından finans sektörüne özel yazılım geliştirme ve teknoloji danışmanlığı sunmak amacıyla kurulan, Balıkesir Teknokent merkezli bir teknoloji şirketidir.",
    },
    {
      question: "Alesta Innovation ne yapar?",
      answer:
        "Finans sektörüne özel yazılım geliştirme, finansal süreç otomasyonu, regülasyon uyumu, veri güvenliği ve sistem entegrasyonu, yapay zeka ve dijital dönüşüm ile teknoloji danışmanlığı hizmetleri sunuyoruz.",
    },
    {
      question: "Kimlere hizmet veriyorsunuz?",
      answer:
        "Finans sektöründeki kurumlarla çalışıyoruz. İş birliği yaptığımız kurumlar arasında DenizBank, Yapı Kredi Faktoring ve Intertech bulunuyor.",
    },
    {
      question: "Size nasıl ulaşabilirim?",
      answer: "info@alestainnovation.com adresine e-posta gönderebilirsiniz.",
    },
  ],
  en: [
    {
      question: "What is Alesta Innovation?",
      answer:
        "Alesta Innovation (Alesta Teknoloji Yazılım ve Danışmanlık Ltd. Şti.) is a technology company based at Balıkesir Teknokent, founded in 2023 by Hüseyin Doruk Tunca and Semih Birincioğlu to provide custom software development and technology consulting for the financial sector.",
    },
    {
      question: "What does Alesta Innovation do?",
      answer:
        "We provide custom software development, financial process automation, regulatory compliance, data security and system integration, AI and digital transformation, and technology consulting for the financial sector.",
    },
    {
      question: "Who do you work with?",
      answer:
        "We work with organizations in the financial sector. They include DenizBank, Yapı Kredi Faktoring and Intertech.",
    },
    {
      question: "How can I contact you?",
      answer: "Email us at info@alestainnovation.com.",
    },
  ],
};
